export { TabsRoot as Root } from "./root/TabsRoot.js";
export { TabsTab as Tab } from "./tab/TabsTab.js";
export { TabsIndicator as Indicator } from "./indicator/TabsIndicator.js";
export { TabsPanel as Panel } from "./panel/TabsPanel.js";
export { TabsList as List } from "./list/TabsList.js";